<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <!-- Nav Header -->
    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon>Back
    </div>
    <div class="header text-left">Edit Popup</div>

    <!-- Image Upload -->
    <v-row class="photo-label">
      <v-col cols="3">
        <label for="cover-photo">Cover Photo</label>
      </v-col>
    </v-row>
    <v-row class="photo-picker">
      <v-col cols="12">
        <input
          style="background-color: #ececec; color: grey"
          disabled
          id="cover-photo"
          type="text"
          v-model="imgUrl"
        />
      </v-col>
    </v-row>

    <!-- Start and End Dates -->
    <v-row class="date-labels">
      <v-col cols="3">
        <label for="startDate">Start Date</label>
      </v-col>
      <v-col cols="3">
        <label>{{ startDate }}</label>
      </v-col>
      <v-col cols="6">
        <input type="datetime-local" id="startDate" v-model="startDate" />
        <div class="error-msg" v-show="$v.startDate.$invalid">
          Start date has to be at least one day from today.
        </div>
      </v-col>
    </v-row>
    <v-row class="date-pickers">
      <v-col cols="3">
        <label for="endDate">End Date</label>
      </v-col>
      <v-col cols="3">
        <label>{{ endDate }}</label>
      </v-col>
      <v-col cols="6">
        <input type="datetime-local" id="endDate" v-model="endDate" />
        <div class="error-msg" v-show="$v.endDate.$invalid">
          End date has to be at least one day from start date.
        </div>
      </v-col>
    </v-row>

    <!-- Schedule -->
    <v-row>
      <v-col cols="6" md="3">
        <label for="popup-schedule">Schedule</label>
        <select id="popup-schedule" v-model="schedule">
          <option disabled value>Select one only</option>
          <option>Daily</option>
          <option>Weekly</option>
          <option>Monthly</option>
          <option>Yearly</option>
        </select>
        <div class="error-msg" v-show="$v.schedule.$invalid">
          This is a required field.
        </div>
      </v-col>
    </v-row>

    <!-- Topics -->
    <v-row>
      <v-col cols="6" md="3">
        <label for="popup-topic">Topic (Select 1 or more)</label>
        <select id="popup-topic" v-model="topics" multiple>
          <option v-for="topic in allTopics" :key="topic._id">
            {{ topic.topic }}
          </option>
        </select>
        <div class="error-msg" v-show="$v.topics.$invalid">
          This is a required field.
        </div>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="title">Title</label>
        <input id="title" type="text" v-model="title" />
        <div class="error-msg" v-show="$v.title.$invalid">
          This is a required field.
        </div>
        <br />
      </v-col>
    </v-row>

    <!-- Body -->
    <v-row>
      <v-col cols="12">
        <label for="popup-body">Body</label>
        <textarea id="popup-body" v-model="body"></textarea>
        <div class="error-msg" v-show="$v.body.$invalid">
          This is a required field.
        </div>
      </v-col>
    </v-row>

    <!-- Button Configurations -->
    <v-row>
      <v-col cols="6" md="4">
        <label for="popup-btn-title">Button Title</label>
        <input id="popup-btn-title" type="text" v-model="btnTitle" />
        <div class="error-msg" v-show="$v.btnTitle.$invalid">
          This is a required field.
        </div>
        <br />
      </v-col>
      <v-col cols="6" md="4">
        <label for="popup-btn-url">Button URL</label>
        <input id="popup-btn-url" type="text" v-model="redirectUrl" />
        <div class="error-msg" v-show="$v.redirectUrl.$invalid">
          Please enter a URL in the following format: http://www.example.com/.
        </div>
        <br />
      </v-col>
    </v-row>

    <!-- Form Submit Button -->
    <v-row>
      <v-col cols="6" md="3">
        <v-btn color="#00457C" :disabled="$v.$invalid" @click="updatePopupForm"
          >Submit</v-btn
        >
      </v-col>
    </v-row>

    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success">Popup updated successfully.</v-alert>
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import LoadingScreen from "./commons/LoadingScreen";
import { required, url } from "vuelidate/lib/validators";

//form validation: check if end date falls after start date
let checkEndDate = (value, vm) => {
  let startDate = new Date(vm.startDate).getTime();
  let input = new Date(value).getTime();

  if (input > startDate) {
    return true;
  } else {
    return false;
  }
};

export default {
  components: {
    LoadingScreen,
  },
  mounted() {
    // Fetch popup detail
    Axios.get(
      process.env.VUE_APP_HOST_SERVER + `/api/popups/get/${this.itemId}`
    )
      .then((res) => {
        this.title = res.data.title;
        this.body = res.data.body;
        this.schedule = res.data.schedule;
        this.topics = res.data.topics;
        this.startDate = moment(res.data.startDate);
        this.endDate = moment(res.data.endDate);
        this.btnTitle = res.data.btnTitle;
        this.redirectUrl = res.data.redirectUrl;
        this.imgUrl = res.data.imgUrl;
      })
      .catch((err) => console.log(err));

    // Fetch all topics
    Axios.get(process.env.VUE_APP_HOST_SERVER + `/api/topics/get_all`)
      .then(({ data }) => {
        console.log("Successfully retrieved all details");
        this.allTopics = data;
      })
      .catch((err) => console.log(err));
  },
  data() {
    return {
      itemId: this.$route.params.itemId,
      title: null,
      body: null,
      schedule: null,
      topics: null,
      startDate: null,
      endDate: null,
      btnTitle: null,
      redirectUrl: null,
      imgUrl: null,
      loading: false,
      success: false,
      error: false,
      allTopics: [],
    };
  },

  validations: {
    title: {
      required,
    },

    body: {
      required,
    },

    startDate: {
      required,
    },

    schedule: {
      required,
    },

    topics: {
      required,
    },

    endDate: {
      required,
      checkEndDate,
    },

    btnTitle: {
      required,
    },

    redirectUrl: {
      required,
      url,
    },
  },

  methods: {
    goBack() {
      this.$router.push({ name: "Popup" }).catch(() => {});
    },
    // TODO: validate redirect url to have http://
    updatePopupForm() {
      this.loading = true; //enable loading screen once user clicks submit
      const startDateTime = this.startDate;
      const endDateTime = this.endDate;

      const updatedPopup = {
        title: this.title,
        body: this.body,
        schedule: this.schedule,
        topics: this.topics,
        startDate: new Date(startDateTime),
        endDate: new Date(endDateTime),
        btnTitle: this.btnTitle,
        btnLink: this.btnLink,
        redirectUrl: this.redirectUrl,
        imgUrl: this.imgUrl,
      };
      // Update Mongodb
      Axios.post(
        process.env.VUE_APP_HOST_SERVER + `/api/popups/edit/${this.itemId}`,
        updatedPopup
      )
        .then(() => {
          console.log("Successfully updated popup ", updatedPopup);
          this.loading = false; //disable loading screen once request is handled
          this.success = true; //show success message
          this.error = false;
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.content .date-labels,
.content .photo-label {
  padding-bottom: 0;
}

.content .date-labels > div,
.content .photo-label > div {
  padding-bottom: 0;
}

.content .date-pickers > div,
.content .photo-picker > div {
  padding-top: 0;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"],
input[type="number"],
input[type="date"],
textarea,
select {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}
</style>
